<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Container from './Container.vue';

    Vue.component('container', Container);
    export default {
        name: 'app'
    };
</script>

<style lang="less">
    @import './default';
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)
    and (orientation : portrait){
        html, body, #app {
            height: 98%;
            min-width: 1000px;
            margin: 0;
        }
        .el-button--small, .el-button--small.is-round{
            padding: 3px 3px;
        }
    }
    .el-table .cell{
        padding: 0px 3px;
        font-size: 10px;
    }
    html, body, #app {
        height: 99%;
        /*min-width: 1200px;*/
        margin: 0;
    }

    body {
        /*overflow-y: hidden;*/
    }

    #app {
        font-size: 16px;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
    }
    ul,li{ padding:0;margin:0;list-style:none}

    button {
        position: relative;
        &:active:after {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            bottom: -1px;
            right: -1px;
            border-radius: inherit;
            border: 0 solid #108ee9;
            opacity: .4;
            -webkit-animation: buttonEffect .4s;
            animation: buttonEffect .4s;
        }
    }

    @keyframes buttonEffect {
        to {
            opacity: 0;
            top: -6px;
            left: -6px;
            bottom: -6px;
            right: -6px;
            border-width: 6px
        }
    }

    //elementUI
    .el-dialog__wrapper {
        display: flex;
        align-items: center;
    }

    .el-message {
        & > i {
            font-size: 14PX;
        }
    }
    .el-pagination.is-background .el-pager li.active {
        background: @orange;
    }
    .el-pagination {
        display: flex;
        justify-content: flex-end;
        margin: 30px 8px;
        .btn-prev, .btn-next {
            background: transparent!important;
            border: 1px solid #dfe4ed!important;
        }
        .el-pager {
            .number {
                background: transparent;
                border: 1px solid #dfe4ed!important;
            }
            li:hover {
                //color: red;
            }
        }
    }
    .el-dialog {
        width: 600px;

        .el-dialog__header {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
    }
</style>




// WEBPACK FOOTER //
// src/App.vue